/* eslint-disable global-require */
const videos = [
  {
    id: 1,
    img: 'https://content.sachso.edu.vn/GiaoVienBanNgu/Primary%20School%20Lesson/cover.jpg',
    url: 'https://content.sachso.edu.vn/GiaoVienBanNgu/Primary%20School%20Lesson/index.html',
    // url: require('../../../assets/Videos/S1.mp4').default,
    name: 'Dành cho HS tiểu học',
    // name: 'Family and Friends 1_Unit 4_Vocabulary',
  },
  {
    id: 2,
    img: 'https://content.sachso.edu.vn/GiaoVienBanNgu/High%20School%20Lesson/cover.png',
    url: 'https://content.sachso.edu.vn/GiaoVienBanNgu/High%20School%20Lesson/index.html',
    name: 'Dành cho HS trung học cơ sở',
    // name: 'English Plus 6_Unit 1_Vocabulary',
  },
];

export default videos;
